const actionStatuses = {
  pending_confirmation: "pending",
  executing: "executing",
  completed: "completed",
  failed: "failed",
  cancelled: "cancelled",
};

function restoredStatus(message) {
  if (message.status === "failed") return "error";
  if (
    ["pending", "processing"].includes(message.status) &&
    !message.content
  ) {
    return "error";
  }
  return "completed";
}

function restoredContent(message) {
  if (message.content) return message.content;
  if (message.status === "failed") {
    return (
      message.metadata?.error ||
      "No se pudo completar esta respuesta."
    );
  }
  if (["pending", "processing"].includes(message.status)) {
    return "Esta respuesta quedó interrumpida antes de completarse.";
  }
  return "";
}

export function normalizeRestoredMessages(messages = [], toolActions = []) {
  const actionsById = new Map(
    toolActions.map((action) => [action.id, action]),
  );

  return messages.map((message) => {
    const metadata = message.metadata || {};
    const status = restoredStatus(message);
    const action = metadata.toolActionId
      ? actionsById.get(metadata.toolActionId)
      : null;

    return {
      id: message.id,
      serverId: message.id,
      role: message.role,
      status,
      content: restoredContent(message),
      citations: message.citations || [],
      warning: metadata.warning || null,
      generatedContent:
        status !== "error" &&
        Boolean(metadata.generatedContent ?? message.generatedByAi),
      evidenceMode: metadata.evidenceMode || null,
      attachments: metadata.attachments || [],
      toolResult:
        metadata.toolName && metadata.toolResult
          ? { name: metadata.toolName, data: metadata.toolResult }
          : null,
      confirmation: action
        ? {
            actionId: action.id,
            toolName: action.toolName,
            workspaceId: action.workspaceId,
            workspaceType: action.workspaceType,
            input: action.input || {},
            status: actionStatuses[action.status] || "failed",
            error: action.error || null,
          }
        : null,
    };
  });
}
